import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class ApiService {
  apiBaseUrl: string;
  // private apiBaseUrl: string = environment.apiBaseUrl;
  // private apiBaseUrl: string = 'https://rossap-albpu-inczsbvqt387-123829850.eu-central-1.elb.amazonaws.com';
  constructor(private http: HttpClient) {
    this.apiBaseUrl = environment.isB2D
      ? environment.b2d.serverURL
      : environment.b2e.serverURL;
    console.log('this.apiBaseUrl', this.apiBaseUrl);
  }

  getVCDTableData(payload: any): Observable<any> {
    return this.http.post(
      `${this.apiBaseUrl}/getDataForInventorySelected`,
      payload
    );
  }

  getNationalScreenData(payload: any): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}/getDataForICDDealer`, payload);
  }

  getRemovedVehiclesDealerInventoryData(payload: any): Observable<any> {
    return this.http.post(
      `${this.apiBaseUrl}/getRemovedVehiclesDealerInventoryData`,
      payload
    );
  }

  getDownloadFiles(payload: any): Observable<any> {
    return this.http.post(
      `${this.apiBaseUrl}/exportInventoryDataToPDFAndCSV`,
      payload
    );
  }

  getCenterInfo(payload: any): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}/getCenterOrDealerInfo`, payload);
  }

  getSelectedFilterData(payload: any): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}/getSelctedFiltersData`, payload);
  }

  getB2DCenterInfo(centerId: string): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}/getCenterId/${centerId}`, {});
  }
}
